Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.adjustableSpacingShape = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _airbnbPropTypes = require('airbnb-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// all values are based on unit size
var adjustableSpacing = {
  NONE: 0,
  MICRO: 0.5,
  TINY: 1,
  SMALL: 2,
  NORMAL: 3,
  SEMI: 4,
  LARGE: 6,
  XLARGE: 8
};

var adjustableSpacingShape = exports.adjustableSpacingShape = (0, _airbnbPropTypes.or)([_propTypes2['default'].oneOf([0.5, 1.5]), (0, _airbnbPropTypes.range)(0, 13)]);
exports['default'] = adjustableSpacing;


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/constants/adjustableSpacing.js
// module id = 119
// module chunks = 168707334958949